var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor","aria-hidden":"true"}},[_c('circle',{attrs:{"cx":"5","cy":"12","r":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"1.5"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"19","cy":"12","r":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }